import React, { useEffect, useMemo, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import "../assets/css/Issues.css";
import "../assets/css/Projects.css";
import "../assets/css/Permissions.css";
import "../assets/css/ViewCustomer.css";
import IssueEditForm from "./issues/IssueEditForm";
import { fetchIssueById } from "./issues/issueService";
import { canPerformActionOnPage, PAGES, ACTIONS } from "../utils/roleAccess";
import { getAuthItem } from "../utils/authStorage";

function EditIssue() {
  const navigate = useNavigate();
  const { issueId } = useParams();
  const role = useMemo(() => {
    try {
      const u = getAuthItem("user");
      if (!u) return null;
      const user = JSON.parse(u);
      const primaryRole = Array.isArray(user.roles) && user.roles.length > 0 ? user.roles[0] : null;
      return (
        (primaryRole && (primaryRole.role_name || primaryRole.name || primaryRole.role)) ||
        user.role_name ||
        user.role ||
        null
      );
    } catch {
      return null;
    }
  }, []);

  const canEdit = canPerformActionOnPage(PAGES.ISSUES, ACTIONS.EDIT, role);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [issue, setIssue] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const data = await fetchIssueById(issueId);
        if (!data) {
          setError("Issue not found.");
          setIssue(null);
        } else {
          setIssue(data);
        }
      } catch (err) {
        console.error("Error fetching issue:", err);
        setError(err.response?.data?.message || err.response?.data?.error || "Failed to load issue.");
        setIssue(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [issueId]);

  return (
    <div className="issues-container">
      <div className="viewlead-header" style={{ marginBottom: 12 }}>
        <button type="button" className="viewlead-back-link" onClick={() => navigate("/issues")}>
          <FaArrowLeft /> Back
        </button>
      </div>

      <div className="issues-main-card">
        {loading ? (
          <div style={{ padding: 18, color: "#5E6C84" }}>Loading issue...</div>
        ) : error ? (
          <div style={{ padding: 18, color: "#c53030" }}>{error}</div>
        ) : (
          <IssueEditForm
            issueId={Number(issueId)}
            issue={issue}
            canEdit={canEdit}
            onIssueRefreshed={(fresh) => setIssue(fresh)}
            onUpdated={(updated) => {
              setIssue(updated);
              alert("Issue updated successfully.");
              navigate("/issues");
            }}
          />
        )}
      </div>
    </div>
  );
}

export default EditIssue;


